
function NavMain() {

    this.build();
    barbaCallbacks.push(this);

}

NavMain.prototype.build = function(){

    $('.header-toggle').unbind('click').on('click', function(){
       $('body').addClass('nav-main--open');
    });

    $('.nav-main-close').unbind('click').on('click', function(){
        $('body').removeClass('nav-main--open');
    });

    new ScrollMagic.Scene(
        {
            triggerElement: '.header-fixed',
            offset: window.innerHeight
        }
    )
    .setClassToggle(".header-fixed, .archive-map-pin", "visible")
    .addTo(scrollController);

};
